<script setup lang="ts">
import copyToClipboard from '@shared/utils/copyToClipboard';
import formatCurrency from '@shared/utils/formatCurrency';
import useFormatStatus from '@shared/utils/useFormatStatus';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import BtnIcon from '../BtnIcon/BtnIcon.vue';
import CountryFlag from '../CountryFlag/CountryFlag.vue';
import StatusBadge from '../StatusBadge/StatusBadge.vue';
import { CelFormatType } from './types';

dayjs.extend(utc);
defineProps<{
	index: number;
	content: unknown;
	type: CelFormatType;
	currency?: string;
}>();
</script>
<template>
	<template v-if="type === 'date' && content">
		<span :data-ts="`table-row-date-${index}`" class="nowrap">
			{{ dayjs.utc(content as Date).format('DD-MM-YYYY HH:mm') }}
		</span>
	</template>

	<div
		v-else-if="type === 'code' && content"
		class="flex nowrap items-center"
		:data-ts="`table-row-code-${index}`"
	>
		<p class="text-monospaced text-neutral-500 items-end gap-4" :title="content">
			{{ content }}
		</p>
		<BtnIcon
			v-if="content && content"
			style="flex-shrink: 0"
			class="ml-1"
			ariaLabel="Copy"
			title="Copy"
			icon-name="bx-copy"
			size="small"
			@click="copyToClipboard(content as string, $event)"
		/>
	</div>

	<template v-else-if="type === 'currency' && content">
		<CountryFlag
			v-if="content"
			:data-ts="`table-row-currency-${index}`"
			:label="content as string"
			:flag="content as string"
		/>
	</template>

	<span
		v-else-if="
			(type === 'value' && content && currency) ||
			(type === 'value' && content === 0 && currency)
		"
		class="text-weight-bold"
		:data-ts="`table-row-value-${index}`"
	>
		{{ formatCurrency(content as number, currency as any) }}
	</span>

	<template v-else-if="type === 'badge' && content">
		<StatusBadge
			v-if="content"
			:data-ts="`table-row-badge-${index}`"
			:label="content as string"
			:status="useFormatStatus(content as string)"
		/>
	</template>

	<span v-else :data-ts="`table-cell`">{{ content ?? '-' }}</span>
</template>
<style scoped lang="scss"></style>
